import React, { createContext, useState, useContext } from 'react';
import { getAIConfigs } from '../services/aiApi';

const AssistantContext = createContext();

export const AssistantProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const sendMessage = async (text) => {
    setMessages((prevMessages) => [
      ...prevMessages,
      { sender: 'User', text },
    ]);
    try {
      const response = await getAIConfigs(text);
      setMessages((prevMessages) => [
        ...prevMessages,
        { sender: 'AI', text: response },
      ]);
    } catch (error) {
      console.error('AI response failed:', error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { sender: 'AI', text: 'Error: Could not get AI response.' },
      ]);
    }
  };

  return (
    <AssistantContext.Provider value={{ messages, sendMessage }}>
      {children}
    </AssistantContext.Provider>
  );
};

export const useAssistant = () => useContext(AssistantContext);